






















































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import SaitenEditTab from "../../components/SaitenEditTab.vue";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";

export interface Data {
  errors: string[]
  loginId: string
  birthday: string
  phone_no: string
}

export default defineComponent({
  components: {
    "saiten-edit-tab": SaitenEditTab,
    "drop-area": DropArea,
    "alert-area": AlertArea,
  },
  setup(props, context){

    /******************************
     * data
     ******************************/
    const state = reactive<Data>({
      errors: [],
      loginId: "",
      birthday: "",
      phone_no: "",
    });

    /******************************
     * ログインボタン押下
     ******************************/
    const onSubmit = async () => {
      
      state.errors = [];

      if(!state.loginId){
        state.errors.push("受験番号を入力してください。");
        return;
      }

      if(!state.birthday){
        state.errors.push("生年月日を入力してください。");
        return;
      }

      if(!state.phone_no){
        state.errors.push("電話番号を入力してください。");
        return;
      }

      const param = {
        school_id: context.root.$route.params.school_id,
        nendo: context.root.$store.state.nendo,
        exec_times: context.root.$store.state.exec_times,
        login_id: state.loginId,
        birthday: state.birthday,
        phone_no: state.phone_no,
      }

      http.post("/api/login/practice_examinee", {condition: param}).then(response => {
        executeLogin(response);
      })
      .catch(error=>{
        if (error.response.status == 401) {
          state.errors.push("ログインに失敗しました。受験番号・生年月日・電話番号を確認してください。");
        }
        if (error.response.status == 403) {
          state.errors.push("試行回数の制限を超えました。管理者に問い合わせてください。");
        }
        if (error.response.status == 406) {
          state.errors.push("現在メンテナンス中のためログインできません。");
        }
        if (error.response.status == 412) {
          state.errors.push("成績情報が公開されていません。公開後にログインできるようになりますので、今しばらくお待ちください。");
        }
      });
    }
    
    /******************************
     * ログイン実行
     ******************************/
    const executeLogin = async (response: any) => {
      var user = response.data.user;

      // トークン設定
      var token = user.access_token
      document.cookie = `access_token=${token}`;
      document.cookie = 'smarky_user_id=' + user.id;
      context.root.$store.commit("setCurrentUser", user);
      context.root.$store.commit("setPracticeExamineeId", response.data.practice_examinee_id);

      context.root.$router.push(`/candidate/result_top`).catch(err => {});
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      await http.get(`/api/master_data/school_logo_image?school_id=${context.root.$route.params.school_id}`).then(response => {
        if(response.data.base64_image == null){
          context.root.$store.commit("setBase64SchoolLogo", require("@/assets/images/logo_smarky_ol.png"));
        }else{
          context.root.$store.commit("setBase64SchoolLogo", `data:image/jpeg;base64,${response.data.base64_image}`);
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          console.log(error.response.data.errors);
        }
      });
      context.root.$store.commit("setNendo", context.root.$route.params.nendo);
      context.root.$store.commit("setExecTimes", context.root.$route.params.exec_times);
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
    });

    return {
      ...toRefs(state),
      onSubmit
    }
  }
})
